import { render, staticRenderFns } from "./PollEditorNumber.vue?vue&type=template&id=184e8b26&scoped=true"
import script from "./PollEditorNumber.vue?vue&type=script&lang=js"
export * from "./PollEditorNumber.vue?vue&type=script&lang=js"
import style0 from "./PollEditorNumber.vue?vue&type=style&index=0&id=184e8b26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184e8b26",
  null
  
)

export default component.exports